import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderData, OrderState } from '../../../../shared/models/order';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Utility } from '../../../../services/utility/util';
import { DanishTimePipe } from "../../../../services/utility/danish-time.pipe";
import { PricePipe } from "../../../../services/utility/price.pipe";

@Component({
    selector: 'app-order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.css'],
    imports: [CommonModule, TranslateModule, DanishTimePipe, PricePipe],
    standalone: true
})
export class OrderDetailsComponent {
    @Input() orderData: OrderData | null = null;
    @Input() locale: string = 'da-DK';

    constructor(private translateService: TranslateService,
        public utility: Utility) { }

    getOrderStatusText(status: OrderState): string {
        switch (status) {
            case OrderState.Ordered: return this.translateService.instant('web.orderedStatus');
            case OrderState.PaymentAuthorized: return this.translateService.instant('web.paymentAuthorizedStatus');
            case OrderState.Paid: return this.translateService.instant('web.paidStatus');
            case OrderState.Refunded: return this.translateService.instant('web.refundedStatus');
            case OrderState.Cancelled: return this.translateService.instant('web.cancelledStatus');
            case OrderState.Deactivated: return this.translateService.instant('web.deactivatedStatus');
            default: return this.translateService.instant('web.unknownStatus');
        }
    }
}
